import helper from '../helpers/ApiUrlHelper.js';
import { authorizedFetch } from '../helpers/http.js';

export default {
  GetApplicationFile(objectName, contentType) {
    return fetch(
      `${helper.apiUrl()}/application-file?objectName=${objectName}&contentType=${contentType}`
    );
  },

  LoadForm(jobofferId) {
    return fetch(`${helper.apiUrl()}/form/${jobofferId}`);
  },

  MapSkillsValue(value) {
    if (value <= 0) {
      return 0;
    } else if (value > 0 && value <= 25) {
      return 1;
    } else if (value > 25 && value <= 50) {
      return 2;
    } else if (value > 50 && value <= 75) {
      return 3;
    } else if (value > 75 && value <= 100) {
      return 4;
    } else {
      return -1;
    }
  },

  async ParseCv(application, objectId, formId, jobofferId) {
    const result = await fetch(
      `${helper.apiUrl()}/parse-cv?objectId=${objectId}&formId=${formId}&jobofferId=${jobofferId}`,
      {
        timeout: 10000
      }
    );
    const cvData = await result.json();

    // this.SetApplicationValue(application, 'firstName', cvData.firstName);
    // this.SetApplicationValue(application, 'lastName', cvData.lastName);
    // this.SetApplicationValue(application, 'email', cvData.emailAddress);
    // this.SetApplicationValue(application, 'salutationId', cvData.salutation);

    return cvData;
  },

  LoadApplicationData(applicationId, email, token) {
    return fetch(
      `${helper.apiUrl()}/application?applicationId=${applicationId}&email=${email}&token=${token}`
    );
  },

  LoadRequestedInformation(applicationId, actionId, token) {
    return fetch(
      `${helper.apiUrl()}/get-requested-information?applicationId=${applicationId}&actionId=${actionId}&token=${token}`
    );
  },

  UpdateAppointment(data) {
    return fetch(`${helper.apiUrl()}/appointment`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  },

  GetInterviewSuggestions(applicationId, authToken) {
    return fetch(`${helper.apiUrl()}/interview-suggestions`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ applicationId, authToken })
    });
  },

  SelectInterviewSuggestion(data) {
    return fetch(`${helper.apiUrl()}/interview-suggestions/select`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  },

  UpdateApplicationData(updatedData) {
    const payload = {
      ApplicationId: updatedData.applicationId,
      ActionId: updatedData.actionId,
      RequestedInformation: updatedData.requestedInformation
    };

    const body = JSON.stringify(payload);
    return fetch(`${helper.apiUrl()}/update-requested-information`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: body
    });
  },

  SaveApplication(applicationData) {
    return authorizedFetch('/application/save', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: this.GetApplicationBody(applicationData)
    });
  },

  SubmitApplication(applicationData) {
    return authorizedFetch('/application', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: this.GetApplicationBody(applicationData)
    });
  },

  GetApplicationBody(applicationData) {
    const payload = {
      sourceApplicationId: applicationData.sourceApplicationId,
      acceptPrivacyPolicy: applicationData.acceptPrivacyPolicy,
      acceptTalentpoolInApplicationProcess:
        applicationData.acceptTalentpoolInApplicationProcess,
      jobofferId: applicationData.jobofferId,
      isInternal: applicationData.isInternal,
      salutationId: applicationData.salutationId,
      title: applicationData.title,
      firstName: applicationData.firstName,
      lastName: applicationData.lastName,
      email: applicationData.email,
      slug: applicationData.slug,
      channel: applicationData.channel,
      channelComment: applicationData.channelComment,
      referrer: applicationData.referrer,
      utm: applicationData.utm,
      letterText: applicationData.letterText,

      basics: applicationData.basics?.map((x) => ({
        dataDefinitionId: x.dataDefinitionId,
        // 0 must not be replaced with an empty string so we can't simply use x.value as the condition
        value:
          x.value !== null && x.value !== undefined ? x.value.toString() : ''
      })),

      questions: applicationData.questions?.map((x) => ({
        questionId: x.questionId,
        // 0 must not be replaced with an empty string so we can't simply use x.value as the condition
        value:
          x.value !== null && x.value !== undefined ? x.value.toString() : ''
      })),

      additionalQuestions: applicationData.additionalQuestions,

      cv: applicationData.cv,
      documents: applicationData.documents,
      customAttachments: Object.keys(applicationData.customAttachments).map(
        (x) => ({
          type: x,
          files: applicationData.customAttachments[x]
        })
      ),
      letter: applicationData.letter,
      disableCvParsing: applicationData.disableCvParsing,
      selectedLanguage: applicationData.selectedLanguage,
      userPhoto: applicationData.photo,
      graphs: applicationData.graphs,
      educationData: applicationData.educationData,
      workData: applicationData.workData
    };

    return JSON.stringify(payload);
  },

  UploadFile(file, fileType) {
    const formData = new FormData();
    formData.append('fileType', fileType);
    formData.append('file', file);

    return fetch(`${helper.apiUrl()}/application-file`, {
      method: 'POST',
      headers: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      body: formData
    });
  },

  SetApplicationValue(application, field, value) {
    if (value) {
      value = value.toString();
    }

    if (!application[field] || application[field] === '') {
      application[field] = value;
    }
  }
};
